import type { Object } from "@suse-o11y/object";
import { toEntries } from "@suse-o11y/to-entries";
import fromPairs from "lodash/fromPairs";
import isPlainObject from "lodash/isPlainObject";
/**
 * A stable JSON.stringify that produces always the same output for the same input.
 *
 * @example
 * toJSON({ b: 1, a: 2 }) === '{"a":2,"b":1}'
 * toJSON({ a: 2, b: 1 }) === '{"a":2,"b":1}'
 *
 * // but
 * JSON.stringify({ b: 1, a: 2 }) === '{"b":1,"a":2}'
 * JSON.stringify({ a: 2, b: 1 }) === '{"a":2,"b":1}'
 */
export function toJSON(value: unknown, spaces: number | string = 0): string {
	return JSON.stringify(
		value,
		(_key, entry: unknown) => {
			if (!isPlainObject(entry)) {
				return entry;
			}

			const sorted = toEntries(entry as Object).sort(([left], [right]) => left.localeCompare(right));

			return fromPairs(sorted);
		},
		spaces,
	);
}
